/**
 * API клієнт для doc.cash_shift_open (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/cash-shift-open. Permissions: retail.shift.open.
 */
import { api } from './client';
import type { Page } from './catalogs';

// Узгоджено з backend DDL CHECK (`shift_status IN ('open', 'closed', 'voided')`).
// Не плутати з generic POST/posted — це окреме поле статусу зміни.
export type ShiftStatus = 'open' | 'closed' | 'voided';

export interface CashShiftOpen {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  pos_workstation_id: string;
  cashier_user_id: string;
  opening_cash_amount: string;
  previous_shift_close_id: string | null;
  shift_status: ShiftStatus;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface CashShiftOpenCreate {
  organization_id: string;
  document_number?: string | null;
  document_date?: string | null;
  pos_workstation_id: string;
  opening_cash_amount?: string;
  previous_shift_close_id?: string | null;
  comment?: string | null;
}

export type CashShiftOpenUpdate = Partial<Omit<CashShiftOpenCreate, 'organization_id' | 'pos_workstation_id'>>;

export const retailCashShiftOpens = {
  list: (params?: {
    organization_id?: string;
    pos_workstation_id?: string;
    shift_status?: ShiftStatus;
    posted?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<CashShiftOpen>>('/retail/cash-shift-open', { params }).then((r) => r.data),
  get: (id: string) => api.get<CashShiftOpen>(`/retail/cash-shift-open/${id}`).then((r) => r.data),
  create: (payload: CashShiftOpenCreate) =>
    api.post<CashShiftOpen>('/retail/cash-shift-open', payload).then((r) => r.data),
  update: (id: string, payload: CashShiftOpenUpdate) =>
    api.patch<CashShiftOpen>(`/retail/cash-shift-open/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/cash-shift-open/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<CashShiftOpen>(`/retail/cash-shift-open/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<CashShiftOpen>(`/retail/cash-shift-open/${id}/unpost`).then((r) => r.data),
};
